"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useCallback, useState } from "react";
import YouTube, { type YouTubeProps } from "react-youtube";
import { cn } from "../../utils/cn";
interface YouTubeResponsiveProps {
  // children can be used to show a custom thumbnail
  children?: (startVideo: () => void, isLoading: boolean) => ReactNode;
  className?: string;
  classNameYt?: string;
  iframeClassName?: string;
  opts?: YouTubeProps["opts"];
  videoId: string;
}
export function YouTubeResponsive(t0) {
  const $ = _c(21);
  const {
    videoId,
    opts: propsOpts,
    className,
    classNameYt,
    iframeClassName,
    children
  } = t0;
  const [showThumbnail, setShowThumbnail] = useState(Boolean(children));
  const [showPlayer, setShowPlayer] = useState(!showThumbnail);
  let t1;
  if ($[0] !== children || $[1] !== propsOpts) {
    t1 = propsOpts || {
      width: 560,
      height: 315,
      playerVars: {
        autoplay: children ? 1 : 0,
        iv_load_policy: 3,
        modestbranding: 1
      }
    };
    $[0] = children;
    $[1] = propsOpts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const opts = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setShowPlayer(true);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const startVideo = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setShowThumbnail(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onReady = t3;
  let t4;
  if ($[5] !== className) {
    t4 = cn("relative aspect-video w-full", className);
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== classNameYt || $[8] !== iframeClassName || $[9] !== opts || $[10] !== showPlayer || $[11] !== videoId) {
    t5 = showPlayer && <YouTube className={cn(classNameYt, "absolute inset-0 h-full w-full")} iframeClassName={cn("h-full w-full", iframeClassName)} onReady={onReady} opts={opts} videoId={videoId} />;
    $[7] = classNameYt;
    $[8] = iframeClassName;
    $[9] = opts;
    $[10] = showPlayer;
    $[11] = videoId;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== children || $[14] !== showPlayer || $[15] !== showThumbnail) {
    t6 = showThumbnail && children?.(startVideo, showThumbnail && showPlayer);
    $[13] = children;
    $[14] = showPlayer;
    $[15] = showThumbnail;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}